import { useCallback } from "react";

import { useRouter } from "next/router";
import { handleConfirmReceipt } from "../../utils/RecieptAndCurrentOrderHelper";
import { OrderTypesEnum, PAYMENT_METHOD, PagesEnum } from "../../utils/enums";
import { isVisitor } from "../../utils/help/user/user";
import { useAppDispatch, useAppSelector } from "./useReduxHooks";

export const usePayHook = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const tableNumber = useAppSelector((state) => state.userInfo.tableNumber);
  const onlinePaymentProvider = useAppSelector(
    (state) => state.config.onlinePaymentProvider
  );

  const { franchise } = router.query;

  const cartAndLoyalty = useAppSelector((state) => state.cartAndLoyaltyReducer);
  const cartLoyaltyV2 = useAppSelector((state) => state.cartLoyaltyV2Reducer);
  const delivery = useAppSelector((state) => state.delivery);
  const token = useAppSelector((state) => state.userInfo.token);
  const deliveryAddress = useAppSelector((state) => state.delivery);
  const orderTypeParamState = useAppSelector(
    (state) => state.queryParams.orderTypeParam
  );
  const referenceName = useAppSelector(
    (state) => state.reference.referenceName
  );
  const restaurantInfo = useAppSelector((state) => state.config.restaurantInfo);

  const { selfService } = useAppSelector((state) => state.franchiseStatus);

  const hasRoundingMethodAndLevel =
    !!restaurantInfo?.currencyRoundingMethod &&
    !!restaurantInfo?.currencyRoundingLevel;

  const scheduledPickup = useAppSelector(
    (state) => state.cartAndLoyaltyReducer.selectedPickupTime
  );

  const pay = useCallback(
    async (
      pageURL: string,
      paymentMethod: PAYMENT_METHOD,
      tips?: number,
      savedCard?: any
    ) => {
      await handleConfirmReceipt({
        pageURL,
        paymentMethod,
        tips,
        savedCard,
        dispatch,
        router,
        orderType: (orderTypeParamState as OrderTypesEnum) || "",
        cartAndLoyalty,
        delivery,
        deliveryAddress,
        franchise: franchise as string,
        referenceName,
        restaurantInfo,
        onlinePaymentProvider,
        tableNumber,
        hasRoundingMethodAndLevel,
        isVisitor: isVisitor(),
        redirectPage: PagesEnum.Home,
        cartLoyaltyV2: cartLoyaltyV2,
        selfService,
        scheduledPickup,
      });
    },
    [
      dispatch,
      router,
      orderTypeParamState,
      cartAndLoyalty,
      delivery,
      deliveryAddress,
      franchise,
      referenceName,
      restaurantInfo,
      onlinePaymentProvider,
      tableNumber,
      hasRoundingMethodAndLevel,
      token,
    ]
  );

  return pay;
};
